import { useEffect, useState } from "react"
import { useNavigate } from "react-router-dom"
import { useAppDispatch, useAppSelector } from "../../../lib/redux/hooks"
import { Layout } from "../../../ui/layout"
import { ButtonComponent } from "../../../ui/molecules/button/newButton"
import { MadfarmInput } from "../../../ui/molecules/input/newInput"
import { MadfarmStaticSelect } from "../../../ui/molecules/select/newSelect/static"
import { CustomHorizontalTab } from "../../../ui/organisms/customHorizontalTab"
import { MenuItems } from "../../../ui/organisms/navbar/dto"
import { MultipleMonthOptions, normativa, yearOptions } from "../../../utils"
import { SOTFilter } from "../../sot"
import { PACCustomerList } from "./customerList"
import { PACList } from "./list"
import { GetAllPacDetails, resetGetAllPACDetailsFilters, resetPACDetailCreationStatus, resetPACDetailUpdateStatus, setGetAllPACDetailsFiltersCountryRegion, setGetAllPACDetailsFiltersHeadquarter, setGetAllPACDetailsFiltersNorm, setGetAllPACDetailsFiltersPeriodicity, setGetAllPACDetailsFiltersYear } from "./slice"
import { periodicityValueGenerator } from "./utils"

export function PAC() {
    const navigate = useNavigate()
    const dispatch = useAppDispatch()
    const sessionState = useAppSelector(state => state.session)
    const pacState = useAppSelector(state => state.pac)
    const [selectedTab, setSelectedTab] = useState<number>(0)
    const [showSuccess, setShowSuccess] = useState<boolean>(false)

    useEffect(() => {
        if (pacState.PACDetailCreationStatus === 'successfully') {
            setShowSuccess(true)
            dispatch(resetPACDetailCreationStatus())
        }
        if (pacState.PACDetailUpdateStatus === 'successfully') {
            setShowSuccess(true)
            dispatch(resetPACDetailUpdateStatus())
        }
    }, [pacState.PACDetailCreationStatus, pacState.PACDetailUpdateStatus])

    useEffect(() => {
        if (showSuccess) {
            setTimeout(() => {
                setShowSuccess(false)
            }, 2000)
        }
    }, [showSuccess])

    return (
        <Layout
            menuItem={MenuItems.GESTIONE_CONTROLLO}
            breadcrumbItems={['Gestione Controllo', 'PAC']}
            noPaddingLat
            headerLabel="Piano Annuale Controllo"
            headerChildren={
                <div className="flex items-center h-[100%] w-[100%] justify-end">
                    <ButtonComponent
                        size={"sm"}
                        iconPosition={"off"}
                        variant={"solid"}
                        label="Crea nuovo"
                        color={"orange"}
                        disabled={!sessionState.selected.customerId}
                        onClick={() => {
                            navigate('/addPacDetail')
                        }}
                    />
                </div>
            }
        >
            <CustomHorizontalTab
                selectedIndex={selectedTab}
                onTabClick={(index) => setSelectedTab(index)}
            >
                <div>Elenco cliente</div>
                <div>Elenco completo</div>
            </CustomHorizontalTab>
            {/* {
                    (selectedTab !== 1 && sessionState.selected.customerId) && (
                        <div style={{padding: '24px 24px 6px 24px'}}>
                            <ClientBanner
                                region={sessionState.selected.customerRegion!}
                                client={sessionState.selected.customerName!}
                                code={sessionState.selected.customerCode!}
                                activity={sessionState.selected.customerActivities ? `${sessionState.selected.customerActivities.map(act => optionsFormatter(act, attivita_bio))}` : undefined}
                                norm={optionsFormatter(sessionState.selected.customerNorm!, normativa)!}
                            />
                        </div>
                    )
                } */}
            {
                (selectedTab !== 0 || sessionState.selected.customerId) && (
                    <div className="flex flex-row items-center gap-2 px-6 pt-6">
                        <MadfarmStaticSelect
                            isClearable
                            placeholder={'Anno'}
                            value={String(pacState.getAllPACDetailsFilters.year)}
                            options={yearOptions}
                            onChange={(value) => {
                                //@ts-ignore
                                const newValue = value !== null ? value.value : null
                                dispatch(setGetAllPACDetailsFiltersYear(Number(newValue)))
                            }}
                            noOptionsMessage={""}
                        />
                        <SOTFilter
                            value={pacState.getAllPACDetailsFilters.head_quarter}
                            // disabled={usersState.findMeResponse.headQuarterInfo?.code !== 'SC' && usersState.findMeResponse.role !== 'admin'}
                            onChange={(value) => dispatch(setGetAllPACDetailsFiltersHeadquarter(value))}
                        />
                        <MadfarmInput
                            placeholder={'Regione'}
                            value={pacState.getAllPACDetailsFilters.country}
                            onChangeText={(value) => dispatch(setGetAllPACDetailsFiltersCountryRegion(value))}
                        />
                        <MadfarmStaticSelect
                            isClearable
                            placeholder={'Periodicità'}
                            value={periodicityValueGenerator(pacState.getAllPACDetailsFilters.periodicity || [])}
                            options={MultipleMonthOptions}
                            onChange={(val) => {
                                const option = val as unknown as { value: string, label: string } | null;

                                const newValue = option?.value || null;
                                if (newValue) {
                                    dispatch(setGetAllPACDetailsFiltersPeriodicity(
                                        newValue.split('-').map((v: string) => Number(v))
                                    ));
                                } else {
                                    dispatch(setGetAllPACDetailsFiltersPeriodicity([]));
                                }
                            }}
                            noOptionsMessage={""}
                        />
                        <MadfarmStaticSelect
                            isClearable
                            placeholder={'Normativa'}
                            value={pacState.getAllPACDetailsFilters.norm}
                            options={normativa}
                            onChange={(value) => {
                                //@ts-ignore
                                const newValue = value !== null ? value.value : null
                                dispatch(setGetAllPACDetailsFiltersNorm(newValue))
                            }}
                            noOptionsMessage={""}
                        />
                        <div className="flex items-center gap-2">
                            <ButtonComponent
                                size={"lg"}
                                iconPosition={"off"}
                                variant={"outline"}
                                label="Pulisci"
                                color={"gray"}
                                onClick={() => dispatch(resetGetAllPACDetailsFilters())}
                            />
                            <ButtonComponent
                                variant='outline'
                                color='orange'
                                size='lg'
                                iconPosition='off'
                                label='Cerca'
                                onClick={() => dispatch(GetAllPacDetails({
                                    page: pacState.getAllPACDetailsFilters.page,
                                    itemsPerPage: pacState.getAllPACDetailsFilters.itemsPerPage,
                                    order: true,
                                    customerId: selectedTab === 0 ? sessionState.selected.customerId! : undefined,
                                    head_quarter: pacState.getAllPACDetailsFilters.head_quarter,
                                    year: pacState.getAllPACDetailsFilters.year,
                                    country: pacState.getAllPACDetailsFilters.country,
                                    norm: pacState.getAllPACDetailsFilters.norm,
                                    periodicity: pacState.getAllPACDetailsFilters.periodicity
                                }))}
                            />
                        </div>
                    </div >
                )
            }
            {
                showSuccess &&
                <div className="gap-[8px] text-left" style={{ margin: '24px', borderRadius: '12px', backgroundColor: '#D1F5D9', borderColor: '#8AE59F', borderWidth: 2 }}>
                    <span className="text-green-700 fieldsetTitle" style={{ padding: '30px 25px', fontSize: '14px', fontFamily: 'Roboto', fontWeight: '700', display: 'block' }}>
                        Dati salvati correttamente.
                    </span>
                </div>
            }
            <div className="fieldset bg-brandPrimary-200">
                {
                    selectedTab === 0 &&
                    <PACCustomerList />
                }
                {
                    selectedTab === 1 &&
                    <PACList />
                }
            </div>
        </Layout >
    )
}